// extracted by mini-css-extract-plugin
export default {"tags":"OLO13SCexSt24THalrci","participationsIcons":"G698xlS7YXdDKl5M_zaR"};